import { useCallback, useEffect, useState } from "react";
import { useCoreContext } from "./CoreContext";
import { useApiContext } from "./ApiContext";
import { Wizard } from "react-use-wizard";
import Flayer from "./Cards/Flayer";
import CustomerForm from "./Cards/Form";
import CardMain from "./Cards/CardMain";
import Permission from "./Cards/Permission";
import moment from "moment/moment";
import * as yup from "yup";
import Complete from "./Cards/Complete";
import { useParams } from "react-router-dom";
import { isMobile, useMobileOrientation } from "react-device-detect";
let CustomerSchema = null;
const MainView = () => {
    const { isLandscape } = useMobileOrientation()
    const { loadConfig } = useCoreContext();
    const { config, setCfg, getSiaCloudConfiguration, getSiaCloudPermission, getEnviroments, saveCustomer, getColori } = useApiContext();
    const [data, setData] = useState(null);
    const [customer, setCustomer] = useState({ nome: "", cognome: "", sesso: "", statocivile: "", cap: "", gg: "", mm: "", aaaa: "", dataDiNascita: null, cellulare: "", email: "", colorepref: null, tagliaAbituale: "", magazzinoInserimento:"",permissions: {} });
    const [fieldTouch, setFieldTouch] = useState({ nome: false, cognome: false, sesso: false, statocivile: "", cap: false, dataDiNascita: false, cellulare: false, email: false, colorepref: null, tagliaAbituale: false });
    const [customerValidation, setCustomerValidation] = useState(false);
    const [formError, setformError] = useState(null);
    const [permissionError, setPermissionError] = useState(null);
    const [colorList, setColorList] = useState([]);
    const [showFlyer, setShowFlyer] = useState(true);
    const {store_code}=useParams();

    useEffect(() => {
        if(config) return;
        const initializeApp = async () => {
            const config = await loadConfig();
            if (config && config.hasOwnProperty("show_flyer")) {
                setShowFlyer(config.show_flyer);
            } else {
                setShowFlyer(true);
            }
            setCfg(config);
        };
        initializeApp();
    }, []);

    useEffect(() => {
        if (!config) return;
        (async () => {
            const {global={}}=window;
            let data = await getSiaCloudConfiguration({
                gruppo:(config.gruppo||"")
            });
            let permission = await getSiaCloudPermission({
                gruppo:(config.gruppo||"")
            });

            let env = await getEnviroments();
            setData(Object.assign({}, data, {
                permessi: permission.map((p) => {
                    if (!p.hasOwnProperty("richiesto")) {
                        p.richiesto = true;
                    }
                    return p;
                }), env: env
            }));
        })();
    }, [config]);

    useEffect(() => {
        if (!data) return;
        const fieldscustomerphysicalperson = Object.assign({
            nome: { mandatory: true },
            cognome: { mandatory: true },
            cellulare: { mandatory: true },
            dataDiNascita: { mandatory: true }

        }, JSON.parse(data.env.properties.fieldscustomerphysicalperson) || {});
        const required = (field) => {
            if (fieldscustomerphysicalperson && fieldscustomerphysicalperson && typeof fieldscustomerphysicalperson[field] === "object" && fieldscustomerphysicalperson[field].mandatory) {
                return true;
            } else {
                return false;
            }
        }
        const shape = ["nome", "cognome", "sesso", "statocivile", "cap", "dataDiNascita", "cellulare", "email", "colorepref", "tagliaAbituale"].reduce((ret, field) => {
            switch (field) {
                case "dataDiNascita":
                    ret[field] = yup.string().nullable();
                    ret[field].test("dataDiNascita", "Devi essere maggiorenne!", function (value) {
                        if ((value || "").length === 10 && moment(value).isValid()) {
                            const years = moment(new Date()).diff(moment(value), 'years');
                            return years >= 18;
                        } else {
                            return true;
                        }
                    });
                    if (required(field)) {
                        ret[field] = ret[field].test("dataDiNascita", "Inserisci un data valida", function (value) {
                            if ((value || "").length === 10 && moment(value).isValid()) {
                                return true;
                            } else {
                                return false;
                            }
                        });
                    } else {
                        ret[field] = ret[field].notRequired();
                    }
                    break;
                case "email":
                    ret[field] = yup.string().email("inserisci un email valida !");
                    if (required(field)) {
                        ret[field] = ret[field].required("Campo obbigatorio");
                    } else {
                        ret[field] = ret[field].notRequired();
                    }
                    break;
                case "cellulare":
                    ret[field] = yup.string().min(10, "Inserisci il numero corretto");
                    if (required(field)) {
                        ret[field] = ret[field].required("Campo obbigatorio");
                    } else {
                        ret[field] = ret[field].notRequired();
                    }
                    break;
                default:
                    ret[field] = yup.string();
                    if (required(field)) {
                        ret[field] = ret[field].required("Campo obbigatorio");
                    } else {
                        ret[field] = ret[field].notRequired();
                    }
                    break;
            }
            return ret;
        }, {});
        CustomerSchema = yup.object().shape(shape);
        /* inizializzo i permessi  */
        if (data.permessi && data.permessi.length > 0) {
            if (!customer.permissions) {
                customer.permissions = {};
            }
            data.permessi.map((p) => {
                if (p.tipologia === "PERMISSION" && !customer.permissions.hasOwnProperty(p.chiave)) {
                    customer.permissions[p.chiave] = false;
                }
            });
        }
        const {global={}}=window;
        customer.magazzinoInserimento=store_code||"";
        customer.gruppo=global.gruppo||"";

        setCustomer(Object.assign({}, customer));
        (async () => {
            setColorList(await getColori());
        })();


    }, [data]);


    const onBlurCustomer = useCallback((el) => {
        const { target } = el;
        const name = (target || {}).name || null;
        if (name) {
            fieldTouch[name] = true;
            setFieldTouch(Object.assign({}, fieldTouch));
        }
    }, [fieldTouch]);

    const onChangeCustomer = (el) => {
        const { target } = el;
        const name = (target || {}).name || null;
        const value = (target || {}).value || "";
        if (name) {
            if (name) {
                fieldTouch[name] = true;
                setFieldTouch(Object.assign({}, fieldTouch));
            }
            const c = Object.assign({}, customer, { [name]: value || null });
            const dataDiNascita = `${c.aaaa}-${c.mm}-${c.gg}`;
            if (moment(dataDiNascita).isValid()) {
                c.dataDiNascita = dataDiNascita;
            } else {
                c.dataDiNascita = null;
            }
            setCustomer(c);
        }
    }
    const onChangePermessi = useCallback((el) => {
        if (customer) {
            const { target } = el;
            const name = (target || {}).name || null;
            const value = ((target || {}).value || "N") === "S";
            if (customer.permissions && name) {
                customer.permissions[name] = value;
                const c = Object.assign({}, customer);
                setCustomer(c);
            }

        }
    }, [customer]);
    useEffect(() => {
        if (!data || !customer) return;
        if (CustomerSchema) {
            const validation = Object.keys(customer).reduce((ret, field) => {
                if (CustomerSchema && CustomerSchema.fields[field]) {
                    const validationField = CustomerSchema.fields[field];
                    try {
                        validationField.validateSync(customer[field]);
                    } catch (er) {
                        ret[field] = er.message;
                    }

                }
                return ret;
            }, {});
            setCustomerValidation(validation);
            setformError(Object.keys(validation).length > 0);
        }


        if (customer && customer.permissions) {
            const permessiValidi = data.permessi.reduce((v, p) => {
                if (p.tipologia === "PERMISSION" && p.richiesto) {
                    if (customer.permissions && !customer.permissions[p.chiave]) {
                        v = false;
                    }
                }
                return v;
            }, true);
            setPermissionError(!permessiValidi);
        }
    }, [fieldTouch, customer, data]);
    const ConfirmData = useCallback(async () => {
        return await saveCustomer(customer);
    }, [customer]);

    const classList=["mainView"];
    if(isMobile){
        classList.push("mobile");
    }else{
        classList.push("desktop");
    }
    if(isLandscape){
        classList.push("landscape");
    }else{
        classList.push("portait");
    }

    return (
        <div className={ classList.join(" ")} >
            {data &&
                <Wizard>
                    {showFlyer && <CardMain back={false} nextText="CONTINUA">
                        <Flayer data={data}></Flayer>
                    </CardMain>
                    }
                    <CardMain back={false} nextText={"CONTINUA"} nextDisabled={formError}>
                        <CustomerForm cfg={data} data={customer} onChange={onChangeCustomer} onBlur={onBlurCustomer} fieldTouch={fieldTouch} errors={formError} touch={fieldTouch} validation={customerValidation} colorList={colorList} > </CustomerForm>
                    </CardMain>
                    <CardMain nextText={"COMPLETA ISCRIZIONE"} nextDisabled={permissionError} nextHandler={ConfirmData}>
                        <Permission data={data} onChange={onChangePermessi} current={customer.permissions}  > </Permission>
                    </CardMain>
                    <Complete customer={customer}></Complete>
                </Wizard>}
        </div>
    );
}
export default MainView;